import React from 'react';

const WhatsAppButton = () => (
  <a
    href="https://wa.me/message/X3F7V43ASQ5UM1"
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-float-btn"
    style={{
      position: 'fixed',
      bottom: '32px',
      right: '32px',
      zIndex: 1000,
      background: 'var(--navy-blue, #1a1a2e)',
      color: 'var(--electric-blue, #2563EB)',
      borderRadius: '50%',
      width: '60px',
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      fontSize: '2rem',
      textDecoration: 'none',
      border: '2px solid var(--electric-blue, #2563EB)',
      transition: 'background 0.2s, border 0.2s',
    }}
    title="Chat with us on WhatsApp"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" aria-label="WhatsApp" style={{display:'block'}}>
      <path d="M16 3C9.373 3 4 8.373 4 15c0 2.65.87 5.1 2.36 7.1L4 29l7.18-2.32C13.07 27.56 14.51 28 16 28c6.627 0 12-5.373 12-12S22.627 3 16 3zm0 22c-1.34 0-2.65-.26-3.87-.77l-.28-.12-4.26 1.38 1.4-4.14-.18-.29C7.26 19.01 7 17.52 7 16c0-5.06 4.13-9.18 9.18-9.18 5.06 0 9.18 4.13 9.18 9.18S21.06 25.18 16 25.18zm5.13-6.13c-.28-.14-1.65-.81-1.9-.9-.25-.09-.43-.14-.61.14-.18.28-.7.9-.86 1.08-.16.18-.32.2-.6.07-.28-.13-1.18-.43-2.25-1.37-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.56.13-.13.28-.34.42-.51.14-.17.18-.29.28-.48.09-.19.05-.36-.02-.51-.07-.14-.61-1.47-.84-2.01-.22-.54-.44-.47-.61-.48-.16-.01-.36-.01-.56-.01-.19 0-.5.07-.76.34-.26.27-1 1.01-1 2.46 0 1.45 1.03 2.85 1.18 3.05.15.2 2.03 3.23 5.01 4.4.7.3 1.25.48 1.68.61.71.23 1.36.2 1.87.12.57-.09 1.75-.72 2-1.42.25-.7.25-1.3.18-1.42-.07-.12-.25-.19-.53-.33z" fill="var(--electric-blue, #2563EB)"/>
    </svg>
  </a>
);

export default WhatsAppButton;
